(function () {
  'use strict';

  function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').replace(/^[:\-–|\s]+|\s+$/g, '').trim();
  }

  function normaliseLabel(value) {
    const label = clean(value).replace(/:$/, '');
    const aliases = {
      'product type': 'Product type',
      'fabric type': 'Fabric',
      fabric: 'Fabric',
      material: 'Fabric',
      colour: 'Colour',
      color: 'Colour',
      craft: 'Craft',
      technique: 'Craft',
      length: 'Length',
      width: 'Width',
      quantity: 'Quantity',
      care: 'Care',
      'care instructions': 'Care',
      dyes: 'Dyes',
      dye: 'Dyes',
      stitching: 'Stitching'
    };
    return aliases[label.toLowerCase()] || '';
  }

  function extractFacts(source) {
    const facts = new Map();
    source.querySelectorAll('li, p').forEach(function (item) {
      const strong = item.querySelector('strong, b');
      let label = '';
      let value = '';

      if (strong) {
        label = normaliseLabel(strong.textContent);
        value = clean(item.textContent.replace(strong.textContent, ''));
      } else {
        const text = clean(item.textContent);
        const separator = text.indexOf(':');
        if (separator > 0 && separator < 30) {
          label = normaliseLabel(text.slice(0, separator));
          value = clean(text.slice(separator + 1));
        }
      }

      if (label && value && !facts.has(label)) facts.set(label, value);
    });
    source.querySelectorAll('tr').forEach(function (row) {
      const cells = row.querySelectorAll('th, td');
      if (cells.length < 2) return;
      const label = normaliseLabel(cells[0].textContent);
      const value = clean(cells[1].textContent);
      if (label && value && !facts.has(label)) facts.set(label, value);
    });
    return facts;
  }

  function renderKeyDetails() {
    const source = document.querySelector('[data-product-details-source]');
    const panel = document.querySelector('[data-product-key-details]');
    const list = document.querySelector('[data-product-key-details-list]');
    if (!source || !panel || !list) return;

    const facts = extractFacts(source);
    const priority = ['Fabric', 'Craft', 'Colour', 'Width', 'Length', 'Quantity', 'Dyes', 'Stitching', 'Care'];
    priority.filter(function (label) { return facts.has(label); }).slice(0, 4).forEach(function (label) {
      const row = document.createElement('div');
      const term = document.createElement('dt');
      const detail = document.createElement('dd');
      term.textContent = label;
      detail.textContent = facts.get(label);
      row.appendChild(term);
      row.appendChild(detail);
      list.appendChild(row);
    });

    if (list.children.length) panel.hidden = false;
  }

  function initialiseMeterPurchase() {
    const purchase = document.querySelector('[data-meter-purchase]');
    if (!purchase) return;
    const display = purchase.querySelector('#qty-new');
    const quantity = purchase.querySelector('input[name="quantity"]');
    const total = purchase.querySelector('[data-meter-total]');
    const pricePerMeter = Number(purchase.dataset.pricePerMeter || 0);
    const currency = purchase.dataset.currency || 'INR';
    let metres = 1;

    function money(cents) {
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: currency, maximumFractionDigits: 2 }).format(cents / 100);
    }

    function update() {
      metres = Math.max(1, Math.round(metres * 4) / 4);
      display.value = metres.toFixed(2) + ' m';
      quantity.value = String(Math.round(metres * 4));
      total.textContent = metres.toFixed(2) + ' m × ' + money(pricePerMeter) + ' = ' + money(pricePerMeter * metres);
      document.dispatchEvent(new CustomEvent('meter:quantity-change', { detail: { metres: metres, total: money(pricePerMeter * metres) } }));
    }

    purchase.querySelectorAll('[data-meter-change]').forEach(function (button) {
      button.addEventListener('click', function () {
        metres += Number(button.dataset.meterChange || 0);
        update();
      });
    });
    update();
  }

  function initialisePage() {
    renderKeyDetails();
    initialiseMeterPurchase();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialisePage);
  } else {
    initialisePage();
  }
})();
